<template>
  <div class="pumpBolusDetailTable_ctn" :class="{ 'pumpBolusDetailTable_ctn--long': isLongLanguage, 'pumpBolusDetailTable_ctn--fullPage': fullPageTable }" :style="style">
    <el-table
      :data="tableData"
      border
      :show-header="false"
      :style="table1Style"
      :cell-class-name="tableCellClassName"
      :row-class-name="tableRowClassName"
    >
      <el-table-column
        prop="c0"
        label=""
        class-name="first-column"
        :width="cellWidth0"
      >
        <template slot-scope="scope">
          <div class="cell_date">
            {{ scope.row.c0 }}
          </div>
          <!-- <div class="cell_date cell-ellipsis cell_date--tip" v-if="!scope.row.isSum"> -->
          <!--   {{ scope.row.c0 }} -->
          <!-- </div> -->
        </template>
      </el-table-column>
      <el-table-column
        v-for="v in maxColumnCountV2"
        :key="`pumpBolusDailyTable_column${v}_${id}`"
        :prop="`c${v}`"
        :class-name="v === maxColumnCountV2 ? 'last-column' : ''"
        label=""
        :width="cellWidth"
      >
        <template slot-scope="scope">
          <span v-if="scope.row['isNoRow'] && scope.row[`c${v}`]" class="isNoCell">{{ scope.row[`c${v}`] }}</span>
          <span v-if="!scope.row['isNoRow']">{{ scope.row[`c${v}`] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>  
</template>
<script>
import reDrawTrigger from '@mx/reDrawTrigger'
import { Table, TableColumn } from 'element-ui'
import dayjs from 'dayjs'
import { derrorFactory, errorFactory } from '@u/log'
import { findObjIndexInArray } from '@u'
import { _getMergedPumpBigDosageFromRecords, _getPumpBigDosageFromRecords } from '@u/reportHelper'
import { bolusDetailNeedSplitColumnNum } from '@u/reportHelperPump'
const derror = derrorFactory('PumpBolusDetailTable.vue', true)
const error = errorFactory('PumpBolusDetailTable.vue', true)

function _emptyUseDash(str) {
  if (['', 'undefined', 'null', 'NULL'].includes(`${str}`)) {
    return '--'
  } else {
    if (`${str}` === '-') {
      return ''
    }
    return `${str}`
  }
}

let _id = 1
export default {
  name: 'CPumpBolusDetailTable',
  components: {
    elTable: Table,
    elTableColumn: TableColumn
  },
  mixins: [reDrawTrigger],
  props: {
    quickPumpTagList: { // 立即大剂量(用户通过泵体的快捷键打的大剂量)
      type: [Array],
      default: () => []
    },
    showMarginRight: {
      type: [Number, Boolean, String],
      default: true
    },
    isLongLang: {
      type: [Number, Boolean, String],
      default: false
    },
    fullPageTable: {
      type: [Boolean],
      default: false
    },
    value: {
      type: [Object],
      default: () => {}
    },
    calculators: {
      type: [Array],
      default: () => []
    },
    otherData: {
      type: [Array],
      default: () => []
    }
  },
  data() {
    _id++
    const id = `bolusdailyt_${+new Date()}_${_id}`
    const { fullPageTable, isLongLang } = this
    let maxColumnCount = bolusDetailNeedSplitColumnNum(this.lang) // 最多多少列
    derror(`fullPageTable: ${fullPageTable}, isLongLang: ${isLongLang}`)
    if (fullPageTable) {
      maxColumnCount = 18
    } else {
      if (isLongLang) {
        // maxColumnCount -= 1
        maxColumnCount -= 0
      }
    }
    return {
      id,
      maxColumnCount
    }
  },
  computed: {
    maxColumnCountV2() {
      const { mergedBigDosage = [] } = this
      const d = 4
      return mergedBigDosage.length === 0 ? d : (Math.max(d, mergedBigDosage.length))
    },
    recommendedRecord() {
      const { otherData = [] } = this
      const filtered = otherData.filter(v => v && +v.eventType === 7)
      // const ratio = /mg/i.test(this.unit) ? 1 : (1 / 18)
      const ratio = 1
      return filtered.map(v => {
        return Object.assign({ ...v }, {
          statusShort1: (ratio * v.statusShort1 / 160).toFixed(3)
        })
      })
    },
    actualBolusRecord() {
      const { otherData = [] } = this
      return []
    },
    activeInsulinRecord() {
      const { otherData = [] } = this
      const filtered = otherData.filter(v => v && +v.eventType === 6)
      // const ratio = /mg/i.test(this.unit) ? 1 : (1 / 18)
      const ratio = 1
      return filtered.map(v => {
        return Object.assign({ ...v }, {
          statusShort0: (ratio * v.statusShort0 / 1000).toFixed(3)
        })
      })      
    },
    sensitivityRecord() {
      const { otherData = [] } = this
      const filtered = otherData.filter(v => v && +v.eventType === 5)
      const ratio = /mg/i.test(this.unit) ? 1 : (1 / 18)
      return filtered.map(v => {
        return Object.assign({ ...v }, {
          statusShort1Ori: v.statusShort1,
          statusShort1: (ratio * v.statusShort1 / 10).toFixed(1)
        })
      })
    },
    carbRatioRecord() {
      const { otherData = [] } = this
      const filtered = otherData.filter(v => v && +v.eventType === 4)
      // const ratio = /mg/i.test(this.unit) ? 1 : (1 / 18)
      const ratio = 1
      return filtered.map(v => {
        return Object.assign({ ...v })
      })
    },
    carbsRecord() {
      const { otherData = [] } = this
      const filtered = otherData.filter(v => v && +v.eventType === 5)
      // const ratio = /mg/i.test(this.unit) ? 1 : (1 / 18)
      const ratio = 1
      return filtered.map(v => {
        return Object.assign({ ...v })
      })
    },
    bgRecord() {
      const { otherData = [] } = this
      const filtered = otherData.filter(v => v && +v.eventType === 6)
      const isMg = /mg/i.test(this.unit)
      const ratio = isMg ? 1 : (1 / 18)
      const fixedNum = isMg ? 0 : 1
      return filtered.map(v => {
        return Object.assign({ ...v }, {
          bloodGlucose: (ratio * v.statusShort1 / 10).toFixed(fixedNum),
          bloodGlucoseOri: (ratio * v.statusShort1 / 10)
        })
      })
    },
    bgSettingRecord() {
      const { otherData = [] } = this
      const filtered = otherData.filter(v => v && +v.eventType === 4)
      const ratio = /mg/i.test(this.unit) ? 1 : (1 / 18)
      return filtered.map(v => {
        const v1 = (ratio * v.statusShort0 / 10).toFixed(1)
        const v2 = (ratio * v.statusShort1 / 10).toFixed(1)
        const middle = ((+(ratio * v.statusShort0 / 10) + +(ratio * v.statusShort1 / 10)) / 2).toFixed(1)
        
        return Object.assign({ ...v }, {
          range: `${Math.min(v2, v1)}-${Math.max(v2, v1)}`,
          middle
        })
      })
    },
    mergedBigDosage() {
      const { value, secondPart, maxColumnCount, fullPageTable } = this
      const { threeChartData = {}} = value
      const { insulinChart = {}} = threeChartData
      const { list2: pumpRecord } = insulinChart
      const bigDosageMinWidthMinutes = 15 // 这个值变了，也要修改ChartDailyPump里头写死的值      
      
      if (!fullPageTable) {
        // 非一整页渲染
        const bigDosage = _getPumpBigDosageFromRecords(pumpRecord, bigDosageMinWidthMinutes)
        const _rst = _getMergedPumpBigDosageFromRecords(bigDosage, bigDosageMinWidthMinutes)
        const rl = _rst.length
        // const rst = secondPart ? _rst.splice(9) : _rst // 其实如果不是secondPart的话，应该取_rst.splice(9)之后的_rst，但这里就懒得处理了
        const rst = rl > maxColumnCount ? _rst.splice(0, maxColumnCount) : _rst // 取前maxColumnCount
        // const rst = Array.from({ length: 22 }).map(v => {
        //   // eslint-disable-next-line
        //   return {}
        // })
        return rst
      } else {
        // 一整页渲染Pump Bolus Detail Table
        // 此时insulinChart.list2为已经处理好的merged big dosage records
        const _rst = pumpRecord
        const rl = _rst.length
        // const rst = rl > maxColumnCount ? _rst.splice(maxColumnCount) : [] // 取偏移maxColumnCount后的数组
        const rst = rl > maxColumnCount ? _rst.splice(0, maxColumnCount) : _rst // 取前maxColumnCount
        // const rst = Array.from({ length: 22 }).map(v => {
        //   // eslint-disable-next-line
        //   return {}
        // })
        return rst        
      }
    },
    cellWidth0() {
      const { lang = 'en', isLongLanguage } = this
      
      // 多语言      
      let rst = 240 // english
      
      // 捷克语再宽一点
      if (isLongLanguage) { // 改成和捷克语一样
        rst = 389
        /* eslint-disable */
        switch(`${lang}`) {
        case 'pl':
          rst = 389
          break
        case 'es': // 西班牙语Carbs Ratio Setting会显示成3行，所以再宽一点
          rst = 380
          break
        case 'cs': // 捷克语再宽一点
        default:
          rst = 389
          break
        }
      }
      /* eslint-enable */
      
      derror(`cellWidth0: ${rst}, lang: ${lang}, isLonglanguage: ${isLongLanguage}`)
      return rst
    },
    cellWidth() {
      const { lang = 'en', isLongLanguage } = this
      
      // 强制都改成90，因为'Bolus Type'已经改成用简称了
      let rst = 96 // english
      if (isLongLanguage) {
        rst = 90
      }
      
      /* eslint-disable */
      switch(`${lang}`) {
      case 'es': // 西班牙语Carbs Ratio Setting会显示成3行，所以这里窄一点
      case 'pl': // 波兰语Carbs Ratio Setting会显示成3行，所以这里窄一点
        rst = 82
        break
      }
      /* eslint-enable */
      
      derror(`cellWidth: ${rst}`)
      return rst
    },
    table1Style() {
      const { cellWidth, cellWidth0, maxColumnCountV2 } = this
      const rst = {
        width: `${cellWidth * maxColumnCountV2 + 2 + cellWidth0}px`,
        marginRight: `2px`,
        'overflow-x': 'hidden'
      }
      return rst
    },
    quickBolusRespectDosageIndexList() { // 立即大剂量(用户通过泵体的快捷键打的大剂量)
      const { value, quickPumpTagList = [], mergedBigDosage = [] } = this
      const { date } = value
      
      if (!quickPumpTagList.length || !mergedBigDosage.length) {
        return []
      }
      
      const dfmt = 'YYYY-MM-DD'
      const currentDateQuickPumps = quickPumpTagList.filter(obj => {
        return dayjs(date).format(dfmt) === dayjs(obj.dateTimeStr).format(dfmt)
      })
      
      const buffer = 60 // 秒为单位;这个buffer用来寻找根据 quickPumpTagList的时间戳，找到到对应的大剂量记录(前后浮动{buffer}时长)
      
      const list = (currentDateQuickPumps.map((obj, i) => {
        const time = obj.dateTimeStr
        
        const respectBigDosageIndex = findObjIndexInArray(mergedBigDosage, { check_time: time }, function _sameTime(v, compareToMeObj) {
          let same = false
          
          const t1 = dayjs(v['check_time'])
          const t2 = dayjs(compareToMeObj['check_time'])
          
          if (Math.abs(t1 - t2) - buffer * 1000 <= 0) {
            same = true
          }
          
          return same
        })
        
        if (respectBigDosageIndex < 0) {
          error(`[接口数据返回有问题但逻辑不会崩]，字段quickPumpTagList的${i}下标的值，其dateTimeStr: ${time}。理论上应该在mergedBigDosage里头应该能找到一条记录记录，其check_time在${time}的前后1分钟. mergedBigDosage: `, mergedBigDosage)
          return undefined
        }
        
        return +respectBigDosageIndex
      })).filter(v => v >= 0)
      
      return list
    },
    tableData() {
      const { maxColumnCount, fullPageTable, value = {}, mergedBigDosage = [], quickBolusRespectDosageIndexList = [], calculators = [] } = this
      const { date } = value
      // const { carbsRecord = [], bloodGlucoseRecord: bgRecord } = value
      const { recommendedRecord = [], actualBolusRecord = [], activeInsulinRecord = [], sensitivityRecord = [], bgSettingRecord = [], carbRatioRecord = [], carbsRecord = [], bgRecord = [] } = this
      derror(`合并后的大剂量记录数: `, mergedBigDosage)
      
      const _isMgUnit = this.unit && /mg/i.test(this.unit)
      
      const l = mergedBigDosage.length
      
      // const _rows = [`Bolus No.`, `Time`, `Bolus Type`, `Recommended Bolus`, `Correction Bolus`, `Difference`, `Carbs`, `Carbs Ratio Setting`, `BG`, `BG Target Setting`, `Insulin Sensitivity`, `Active Insulin`]
      const _rows = [`Bolus No.`, `Time`, `BG`, `BG Target Setting`, `Bolus Type`, `Carbs`, `Carbs Ratio Setting`, `Meal Bolus`, `Correction Bolus`, `Insulin Sensitivity`, `Active Insulin`, `Recommended Bolus`, `Difference`, `Bolus Delivery`]
      
      const rst = _rows.map((k, i) => {
        const rst = { c0: this.$t(k) }
        if (k === `Bolus No.`) {
          rst.isNoRow = true
        }
        if (i + 1 === _rows.length) {
          // 最后一行
          rst.isLastRow = true
        }
        return rst
      })
      
      const buffer4CarbsAndGlu = 1000 * 60 // 1分钟;获取Carbs和BG的记录的偏移量，最多1分钟
      
      for (let i = 0; i < l; i++) {
        const bigDosage = mergedBigDosage[i]
        
        const columnK = `c${i + 1}`
        
        // Bolus No.
        const bIndex = _rows.indexOf(`Bolus No.`)
        rst[bIndex][columnK] = (i + 1 + (fullPageTable ? bolusDetailNeedSplitColumnNum(this.lang) : 0))
        
        // Time
        const bIndex1 = _rows.indexOf(`Time`)
        rst[bIndex1][columnK] = dayjs(bigDosage['check_time']).format('HH:mm')
        
        // Bolus Type
        const bIndex2 = _rows.indexOf(`Bolus Type`)
        const row2tmp = bigDosage['type']
        
        const row2TypeArr = (Array.isArray(row2tmp) ? row2tmp : [row2tmp]).map(type => {
          if (quickBolusRespectDosageIndexList.includes(i)) {
            return this.$t('Quick Bolus Abbreviation')
            // return 'quick'
          } else {
            if (`${type}`.trim() === '0') {
              // 立即大剂量
              return this.$t('Normal Bolus Abbreviation')
              // return 'normal'
            } else if (`${type}`.trim() === '1') {
              // 延长大剂量
              return this.$t('Extended Bolus Abbreviation')
              // return 'extended'
            } else if (`${type}`.trim() === '2') {
              // 双波大剂量
              return this.$t('Dual Wave Abbreviation')
              // return 'Dual-wave'
            } else {
              return '--'
            }
          }
        })
        
        rst[bIndex2][columnK] = (row2TypeArr.map(str => this.$t(str))).join('+')
        if (rst[bIndex2][columnK] === `normalny+złożony`) { // 波兰语，normal+extended要改成直接显示extended的对应波兰词
          rst[bIndex2][columnK] = 'złożony'
        }
        
        // 计算Carbs和BG的准备工作，给有大剂量计算器的大剂量打上标记
        // let thisDosageHasCal = false // 这个大剂量记录是否有对应的'大剂量计算器记录'
        const stime = bigDosage.check_time
        const _isDualWaveBigDosage = +bigDosage.type === 2
        let bigDosageMergedCounts = 1
        if (_isDualWaveBigDosage) {
          const keys = (Object.keys(bigDosage).filter(k => /true_check_time/i.test(k)))
          bigDosageMergedCounts = keys.length
          derror(`bigDosageMergedCounts : ${bigDosageMergedCounts}, bigDosage: `, bigDosage)
        }
        
        // 判断此大剂量，是否有'大剂量计算器'
        const stimeNums = Array.from({ length: bigDosageMergedCounts }).map((v, i) => {
          const k = i === 0 ? `true_check_time` : `true_check_time${i + 1}`
          derror(`k: ${k}, value: ${bigDosage[k]}`)
          return +dayjs(bigDosage[k])
        })
        // console.error(`stimeNums: ${stimeNums}`)
        const cl = calculators.length        
        
        // 计算 Recommended Bolus
        let recommendedRst
        const belongToThisDosageRecommended = recommendedRecord.filter(belongToThisDosageFilterHelperFactory('carbo', stimeNums))
        
        // 排序一下，取最靠近这一条大剂量时间の记录
        if (belongToThisDosageRecommended.length) {
          recommendedRst = belongToThisDosageRecommended.sort(_asc)[0]
        }
        
        // 画Recommended到表格
        const bIndex3 = _rows.indexOf(`Recommended Bolus`)
        rst[bIndex3][columnK] = _emptyUseDash(recommendedRst ? recommendedRst['statusShort1'] : '')
        // if (rst[bIndex3][columnK]) {
        //   rst[bIndex3][columnK] += 'U'
        // }
        
        // 计算 Correction Bolus和 Meal Bolus
        const bIndex4 = _rows.indexOf(`Correction Bolus`)
        const bIndex12 = _rows.indexOf(`Meal Bolus`)
        const belongToThisDosageCarbRatio0 = (bgSettingRecord.filter(belongToThisDosageFilterHelperFactory('correction,carb ratio', stimeNums)).sort(_asc))[0] // 获得碳水化合物系数
        const belongToThisDosageCarb = (carbsRecord.filter(belongToThisDosageFilterHelperFactory('correction,carb', stimeNums)).sort(_asc))[0] // 获得碳水化合物
        const belongToThisDosageBg0 = (bgRecord.filter(belongToThisDosageFilterHelperFactory('correction,bg', stimeNums)).sort(_asc))[0]
        const belongToThisDosageSensitivity0 = (sensitivityRecord.filter(belongToThisDosageFilterHelperFactory('correction,sensitivity', stimeNums)).sort(_asc))[0]
        if (i >= 4) {
          const arr = (sensitivityRecord.filter(belongToThisDosageFilterHelperFactory('correction,sensitivity', stimeNums)).sort(_asc))
        }
        let correctionBg
        let mealBolus
        if (belongToThisDosageCarbRatio0 && belongToThisDosageCarb) {
          if (belongToThisDosageCarbRatio0['statusByte1'] !== undefined && belongToThisDosageCarb['statusShort0'] !== undefined) {
            const _ratio = +belongToThisDosageCarbRatio0['statusByte1']
            const carbs = +belongToThisDosageCarb['statusShort0']
            const ratioFloat = +belongToThisDosageCarbRatio0['eventValue']
            const ratio = `${_ratio}.${ratioFloat}` // equil5.4.0及以后版本、equils所有版本； (24年11月20日欧阳晨露发的邮件)拿到的碳水化合物系数（ event_port为0，event_type为4），status_byte1字段保持不变，存储的是 碳水化合物系数的整数位。这次变更，用event_value字段存储 碳水化合物系数的小数位。例如 status_byte1的值为1， event_value的值为2。那么，碳水化合物系数的值就是1.2。以上功能从5.4.0开始，以后的所有常规版都是如此。
            if (+ratio !== 0) {
              mealBolus = (carbs / ratio).toFixed(1)
            }
          }
          
          if (belongToThisDosageBg0 !== undefined) {
            // const bg = +belongToThisDosageBg0['bloodGlucose']
            const bg = +belongToThisDosageBg0['bloodGlucoseOri']
            const range = belongToThisDosageCarbRatio0.range
            const arr = range.split('-')
            const min = +arr[0]
            const max = +arr[1]
            
            if (bg - min >= 0 && bg - max <= 0) {
              // 不矫正
              correctionBg = 0
            } else {
              correctionBg = bg - (min + max) / 2
            }
          }
        }
        
        // 画Correction Bolus到表格
        const _isUnitMg = /mg/i.test(this.unit)
        const _correctionBgRatio = _isUnitMg ? 1 : 18
        rst[bIndex4][columnK] = _emptyUseDash((correctionBg !== undefined && belongToThisDosageSensitivity0 !== undefined && belongToThisDosageSensitivity0['statusShort1'] !== undefined) ? (Math.abs(correctionBg * _correctionBgRatio) / (belongToThisDosageSensitivity0['statusShort1Ori'] / 10)).toFixed(1) : '')
        // if (!['', undefined, null].includes(rst[bIndex4][columnK])) {
        //   rst[bIndex4][columnK] += 'U'
        // }
        // 画meal bolus到表格
        rst[bIndex12][columnK] = _emptyUseDash(mealBolus !== undefined ? `${mealBolus}` : '')
        // if (!['', undefined, null].includes(rst[bIndex12][columnK])) {
        //   rst[bIndex12][columnK] += 'U'
        // }
        
        // 计算 difference
        const _d1 = bigDosage.data // data已经是合并后得了
        const _isExtend = `${bigDosage.type}` === '1'
        const _isSplitedExtend = `${bigDosage.type}` === '1' && bigDosage.extendId && bigDosage.extendIdFirstOne
        const _isDual = `${bigDosage.type}` === '2'
        let thisDosageTrueV = 0
        
        if (_isDual) {
          derror(`[计算器]双波数据:`, bigDosage)
          // const dataKeys = (Object.keys(bigDosage)).filter(k => /^data[\d]*/.test(k))
          thisDosageTrueV = +bigDosage['dualTotalBolus']
          // thisDosageTrueV = dataKeys.reduce((rst, cur) => {
          //   const k = cur
          //   return rst + (+bigDosage[k])
          // }, 0)
        } else if (_isSplitedExtend) {
          // console.error(`[计算器]分割的延长量数据:`, bigDosage)
          thisDosageTrueV = +bigDosage.totalExtendBolus
        } else { // 立即量,或者没有被分割的延长量
          thisDosageTrueV = bigDosage.data
        }
        
        // if (_d1 && !Number.isNaN(+_d1)) {
        //   thisDosageTrueV += +_d1
        // }
        // 画difference到表格
        const bIndex5 = _rows.indexOf(`Difference`)
        const differenceNegative = (recommendedRst && recommendedRst.statusShort1 && thisDosageTrueV) ? ((thisDosageTrueV - recommendedRst.statusShort1 < 0)) : false
        rst[bIndex5][columnK] = _emptyUseDash((differenceNegative ? '-' : '') + ((recommendedRst && recommendedRst.statusShort1 && thisDosageTrueV) ? (Math.abs(recommendedRst.statusShort1 - thisDosageTrueV).toFixed(1)) : ''))
        
        if (['-0.0', '-0'].includes(`${rst[bIndex5][columnK]}`)) {
          const s = rst[bIndex5][columnK]
          rst[bIndex5][columnK] = s.replace('-', '')
        }
        
        // if (rst[bIndex5][columnK]) {
        //   rst[bIndex5][columnK] += 'U'
        // }
        
        // 计算Carbs
        // let carbsRst
        // const belongToThisDosageCarbs = carbsRecord.filter(belongToThisDosageFilterHelperFactory('carbo', stimeNums))
        
        // // 排序一下，取最靠近这一条大剂量时间の记录
        // if (belongToThisDosageCarbs.length) {
        //   carbsRst = belongToThisDosageCarbs.sort(_asc)[0]
        // }
        const carbsRst = belongToThisDosageCarb
        
        // 画Carbs到表格
        const bIndex6 = _rows.indexOf(`Carbs`)
        rst[bIndex6][columnK] = _emptyUseDash(carbsRst ? carbsRst['statusShort0'] : '')
        // if (rst[bIndex6][columnK]) {
        //   rst[bIndex6][columnK] += 'g'
        // }
        
        // 计算carb ratio setting
        let carbRatioRst
        const belongToThisDosageCarbRatio = carbRatioRecord.filter(belongToThisDosageFilterHelperFactory('carboRatio', stimeNums))
        
        // 排序一下，取最靠近这一条大剂量时间の记录
        if (belongToThisDosageCarbRatio.length) {
          carbRatioRst = belongToThisDosageCarbRatio.sort(_asc)[0]
        }
        
        // 画CarbRatio到表格
        const bIndex7 = _rows.indexOf(`Carbs Ratio Setting`)
        rst[bIndex7][columnK] = _emptyUseDash(carbRatioRst ? carbRatioRst['statusByte1'] : '')
        // if (rst[bIndex7][columnK]) {
        //   rst[bIndex7][columnK] += 'g carb/U'
        // }
        // 计算Bg
        let bgRst
        const belongToThisDosageBg = bgRecord.filter(belongToThisDosageFilterHelperFactory('bg', stimeNums))
        
        // 排序一下，取最靠近这一条大剂量时间の记录
        if (belongToThisDosageBg.length) {
          bgRst = belongToThisDosageBg.sort(_asc)[0]
        }
        
        // 画BG到表格
        const bIndex8 = _rows.indexOf(`BG`)
        // rst[bIndex8][columnK] = bgRst ? `${bgRst['bloodGlucose']}${this.unit}` : ''
        rst[bIndex8][columnK] = _emptyUseDash(bgRst ? `${bgRst['bloodGlucose']}` : '')
        
        // 计算Bg target setting
        let bgSettingRst
        const belongToThisDosageBgSetting = bgSettingRecord.filter(belongToThisDosageFilterHelperFactory('bgSetting', stimeNums))
        
        // 排序一下，取最靠近这一条大剂量时间の记录
        if (belongToThisDosageBgSetting.length) {
          bgSettingRst = belongToThisDosageBgSetting.sort(_asc)[0]
        }
        
        // 画BGSETTING到表格
        const bIndex9 = _rows.indexOf(`BG Target Setting`)
        const bIndex9DigitNum = _isMgUnit ? 0 : 1
        // rst[bIndex9][columnK] = bgSettingRst ? `${bgSettingRst['range']}${this.unit}` : ''
        rst[bIndex9][columnK] = _emptyUseDash(bgSettingRst ? `${(+bgSettingRst['middle']).toFixed(bIndex9DigitNum)}` : '')
        
        // 计算Insulin Sensitivity
        let sensitivityRst
        const belongToThisDosageSensitivity = sensitivityRecord.filter(belongToThisDosageFilterHelperFactory('sensitivity', stimeNums))
        
        // 排序一下，取最靠近这一条大剂量时间の记录
        if (belongToThisDosageSensitivity.length) {
          sensitivityRst = belongToThisDosageSensitivity.sort(_asc)[0]
        }
        
        // insulin sensitivity画到表格
        const bIndex10 = _rows.indexOf(`Insulin Sensitivity`)
        // rst[bIndex10][columnK] = sensitivityRst ? `${sensitivityRst['statusShort1']}${this.unit}/U` : ''
        rst[bIndex10][columnK] = _emptyUseDash(sensitivityRst ? `${sensitivityRst['statusShort1']}` : '')
        
        // 计算ActiveInsulin
        let activeInsulinRst
        const belongToThisDosageActiveInsulin = activeInsulinRecord.filter(belongToThisDosageFilterHelperFactory('activeInsulin', stimeNums))
        
        // 排序一下，取最靠近这一条大剂量时间の记录
        if (belongToThisDosageActiveInsulin.length) {
          activeInsulinRst = belongToThisDosageActiveInsulin.sort(_asc)[0]
        }
        
        // 画active insulin到表格
        const bIndex11 = _rows.indexOf(`Active Insulin`)
        rst[bIndex11][columnK] = _emptyUseDash(activeInsulinRst ? `${activeInsulinRst['statusShort0']}` : '')
        // if (rst[bIndex11][columnK]) {
        //   rst[bIndex11][columnK] += 'U'
        // }
        
        // 计算Bolus Delivery
        // 画active insulin到表格
        const bIndex13 = _rows.indexOf(`Bolus Delivery`)
        rst[bIndex13][columnK] = _emptyUseDash(thisDosageTrueV ? `${(thisDosageTrueV).toFixed(3)}` : '')
        if (_isExtend && +thisDosageTrueV === 0) {
          // 延长大剂量为0的时候，要显示
          error(`[逻辑注意]延长大剂量总剂量连0.025都没打到，所以值是0,此时在大剂量计算器的详情表里头要显示0.000, bigDosage:`, bigDosage)
          rst[bIndex13][columnK] = '0.000'
        }
      }
      
      // console.error(`大剂量计算器rst`, rst)
      return rst
      
      function belongToThisDosageFilterHelperFactory(what, stimeNums = []) {
        return function (v) {
          const t = v['dateTimeStr']
          if (t === undefined) {
            error(`计算${what}，发现${what}的每一项，没有dateTimeStr，直接失败,这是不允许的`)
            return false
          }
          
          const startNum = +dayjs(t)
          
          let pass = false
          stimeNums.forEach(stimeNum => {
            // // 保留大剂量的前面一分钟内的所有记录
            // const p = (startNum + buffer4CarbsAndGlu) - stimeNum >= 0 && startNum - stimeNum <= 0
            // Update
            // 保留大剂量的前后一分钟内的所有记录
            const p = Math.abs(startNum - stimeNum) - buffer4CarbsAndGlu <= 0
            
            if (p) {
              pass = true              
            }
            derror(`[PumpBolusDetailTable.vue]what: ${what}, pass: ${pass}, stimeNums: ${stimeNums} stimeNum: ${stimeNum}——${dayjs(stimeNum).format('YYYY-MM-DD HH:mm:ss')}, t: ${t}, +t: ${+dayjs(t)}, gap: ${Math.abs(startNum - stimeNum)}, buffer4CarbsAndGlu: ${buffer4CarbsAndGlu}`)
          })
          
          return pass 
        }
      }
      
      function _desc(first, second) {
        return dayjs(second.dateTimeStr) - dayjs(first.dateTimeStr) // > 0, 意味着 second的时间戳比first要大，给first和second换位置(即，first挪到second之后)
      }
      
      function _asc(first, second) {
        return dayjs(first.dateTimeStr) - dayjs(second.dateTimeStr) // > 0, 意味着 first的时间戳比second要大，把first和second换位置(即，first挪到second之后，也就是时间更迟的在后面)
      }
    },
    h() {
      const dh = this.dh
      
      const r = 221 / 1240
      // derror(`[bar]computed h: ${dh}, rst: ${r * dh}`)
      return r * dh
    },
    w() {
      const ds = this.ds
      
      const r = 455 / 1754
      // error(`[bar]computed w: ${ds}, rst: ${r * ds}`)
      return r * ds
    },
    style() {
      const { showMarginRight, zoomRatio, isLongLanguage } = this
      const rst = { zoom: zoomRatio * 0.836 } // 测试反馈，页面能渲染，但是当他点击打印，然后打印预览的时候，发现这个表格消失了，应该是太大导致溢出了

      if (isLongLanguage) {
        // rst.zoom = rst.zoom * 0.9
        // rst.zoom = rst.zoom * 0.8999
        rst.zoom = rst.zoom * 1
      } else {
        rst.zoom = rst.zoom * 0.9
        // rst.zoom = rst.zoom * 1
      }
      if (`${showMarginRight}`.toLowerCase().trim() !== `false` && showMarginRight) {
        rst.marginRight = Math.floor(zoomRatio * 20) + 'px'
      }
      return rst
    }
  },
  mounted() {
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      const i = `${rowIndex}`
      if (i === '0') {
        return 'first-row'
      } else if (row && row.isLastRow) {
        return 'last-row'
      }
      return ''
    },
    tableCellClassName({ row = {}, column = {}}) {
      const { property = '' } = column
      const ps = `${property}`
      if (ps === 'cell11') {
        return 'corner_cell--bright'
      }
      return ''
    }
  }
}
</script>
<style lang="scss" scoped>
$br: 0.8em;  
$br--px: 8px;
$fs--px: 14px;
$fs-small--px: 12px;
$fs-large--px: 16px;
$fs-biggest--px: 20px;
$c: #454545;
$c-tableStripped: #E7F1EC;

@import '@/styles/mixin';
@import '@/styles/variables';
::v-deep .el-table {    
    color: $c;
    .cell-ellipsis {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    &.el-table--border {
        border-radius: $br--px;
        border-radius: $br;
    }
    .cell {
        padding: 0 0;
        padding-left: 0;
        line-height: 18px;
        font-size: 16px;
        font-size: $fs-biggest--px;
        > span {
            display: inline-block;
            &.isNoCell {
                background-color: #0f7a44;
                color: white;
                padding: 2px 4px;
                display: inline-block;
                $h: 1.2em;
                width: 1.3em;
                height: $h;
                line-height: $h;
                text-align: center;
            }
        }
    }
    .el-table__cell {
        padding: 0 0;
    }
    tr.el-table__row > .el-table__cell {
        position: relative;
        > .cell {
            height: 100%;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            > div {
                flex-grow: 1;
                word-break: break-word;
                /* word-break: break-all; */
                width: 100%;
                /* overflow: hidden; */
                /* white-space: nowrap; */
                /* text-overflow: ellipsis; */
                /* @include heightMiddle($rowH); */
                height: $rowH;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                text-align: center;
            }
        }
    }
}
::v-deep .el-table--border .el-table__cell:first-child .cell {
    padding-left: 0;
}
::v-deep .withSplitter {
    > td {
        border-bottom: 2px solid black;
    }
}
.cell_date {
    text-align: right;
    font-size: $fs-small--px;
    &.cell_date--tip {
        font-size: $fs-small--px;
        opacity: 0.6;
    }
    &.cell_date--isSum {
        @include flexColumn(space-around, flex-end);
    }
}
.first-column .cell_date {
    font-size: $fs-biggest--px;
}
.pumpBolusDetailTable_ctn--long .cell_date {
    font-size: $fs-large--px;
    font-size: 20px;
}

::v-deep .el-table__header-wrapper {
    > table {
        height: 40px;
        background-color: #FAFAFA;
    }
    thead > tr > th {
        overflow: visible;
        border-right: 0;
        background-color: #D8D8D8;
        height: 48px;
        > .cell {
            left: -1.4em;
            padding-left: 0;
            padding-right: 0;
            font-size: $fs--px;
        }
        &:nth-last-child(2) {
            > .cell {
                left: 0;
                overflow: visible;
                white-space: nowrap;
                direction: rtl;
                text-indent: 2px;
            }
        }
    }
}
::v-deep .el-table__footer-wrapper {
    .el-table__footer {
        height: 36px;
        tbody > tr > td.el-table__cell {
            text-align: center;
        }
    }    
}
::v-deep .el-table--striped .el-table__body {
    tr.el-table__row td.el-table__cell {
        background: #FAFAFA;
        background: aliceblue;
        background: $colorGluMesurementLabelBg;
        /* background-color: rgba(15, 122, 68, 0.10); */
    }
    
    tr.el-table__row--striped td.el-table__cell {
        background: white;
    }    
}
.pumpBolusDetailTable_ctn {
    &.pumpBolusDetailTable_ctn--fullPage {
        margin-top: 2rem;
    }
    ::v-deep {
        box-sizing: border-box;
        overflow: hidden;
        .corner_cell--bright {
            border-bottom-right-radius: $br--px;
            border-bottom-right-radius: $br;
        }
        .corner_cell--bottom {
            border-bottom-left-radius: $br--px;
            border-bottom-left-radius: $br;
            border-bottom-right-radius: $br--px;
            border-bottom-right-radius: $br;
        }
        .cell_padRight {
            border-right: 10px solid #d8d8d8;
        }

        > div.el-table {
            display: inline-block;
            border: 1px solid $colorGluMesurementInnerBorder;
            tr.el-table__row {
                height: $rowH;
                @include bBox;
                &.last-row {
                    height: $rowH + 1px;
                }
            }
        }
    }

    ::v-deep .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
        border-bottom: 1px solid $colorGluMesurementInnerBorder;
    }
    ::v-deep .el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid $colorGluMesurementInnerBorder;
        /* border-right-width: 0; */
    }
    ::v-deep .el-table .first-row, ::v-deep .el-table .first-column {
        background-color: $c-tableStripped;
    }
    ::v-deep .el-table .first-row td.el-table__cell {
        border-top: 1px solid $colorGluMesurementInnerBorder;
        border-top-width: 0;
        &:first-child {
            border-top-left-radius: 1em;
        }
        &:last-child {
            border-top-right-radius: 1em;
        }
    }
    ::v-deep .el-table .last-row td.el-table__cell {
        border-bottom: 2px solid $colorGluMesurementInnerBorder;
        border-bottom-width: 0;
        &:first-child {
            border-bottom-left-radius: 1em;
        }
        &:last-child {
            border-bottom-right-radius: 1em;
        }        
    }
    ::v-deep .el-table td.el-table__cell.first-column {
        border-left: 1px solid $colorGluMesurementInnerBorder;
        border-left-width: 0;
        > .cell {
            > .cell_date {
                align-items: flex-start;
                text-align: left;
                /* text-indent: 0.2em; */
                padding: 0 0.2em;
                box-sizing: border-box;
            }
        }
    }
    ::v-deep .el-table td.el-table__cell.last-column {
        border-right-width: 0;
    }
}
</style>
